import styled from "styled-components";
import { mobile } from "../../../../../ui/_themes/constants";
import { MenuNavButton } from "../../../../../ui/MenuNavButton";
import { menuIndicatorPosition } from "./Indicator";

export const StyledMenuNavButton = styled(MenuNavButton)`
  display: inherit;
  align-items: center;
  justify-content: center;
  flex: 0 0 ${props => 100 / props.numOfTabs}%;
  position: relative;
  transition: color 100ms ease;

  @media (orientation: landscape) {
    /* A bug in Safari causes these cells to shrink to 0 in height unless we make sure it's allowed to grow */
    flex-grow: 1;

    svg {
      width: ${mobile.landscape.sidePanel.icon.width};
      height: ${mobile.landscape.sidePanel.icon.height};
    }
  }

  @media (orientation: portrait) {
    svg {
      width: ${mobile.portrait.middlePanel.navigation.icon.width};
      height: ${mobile.portrait.middlePanel.navigation.icon.height};
    }
  }

  ${menuIndicatorPosition};
`;
